import script from "./Item.vue?vue&type=script&lang=ts&setup=true"
export * from "./Item.vue?vue&type=script&lang=ts&setup=true"

import "./Item.vue?vue&type=style&index=0&id=ef568a4e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef568a4e"]])

export default __exports__